import { render, staticRenderFns } from "./LastResultTab.vue?vue&type=template&id=74054db8"
import script from "./LastResultTab.vue?vue&type=script&lang=js"
export * from "./LastResultTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports